import { Injectable } from '@angular/core';

@Injectable()
export class FormSuccessService {

  success: boolean = false;

  submissionSuccessful(): boolean {
    return this.success;
  }

  setSuccess(outcome: boolean): void {
    this.success = outcome;
  }
}
